import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { NOVA_URL } from "../data/site";

const paragraphs = [
  "Inceptica builds enterprise AI products that solve complex business challenges.",
  "Our flagship product, Nova, helps organisations simplify compliance and certification through intelligent automation.",
  "Alongside our products, we provide selected AI consulting and IT services for organisations adopting AI and digital transformation.",
  "Our team combines expertise across product strategy, engineering, security, compliance and customer success to build solutions that customers love.",
];

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 lg:py-32 bg-zinc-50 border-y border-zinc-200">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="text-xs font-bold tracking-[0.2em] uppercase text-blue-600">
                About
              </span>
              <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-zinc-900 leading-tight">
                An AI product company, with Nova at its core
              </h2>
              <a
                href={NOVA_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="about-explore-nova-link"
                className="group mt-8 inline-flex items-center gap-2 text-sm font-medium text-zinc-900"
              >
                <span className="border-b border-zinc-300 group-hover:border-zinc-900 pb-0.5 transition-colors">
                  Explore Nova
                </span>
                <ArrowUpRight className="w-4 h-4 text-blue-600 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </Reveal>
          </div>

          <div className="lg:col-span-7 space-y-6">
            {paragraphs.map((p, i) => (
              <motion.p
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                className="text-lg text-zinc-700 leading-relaxed"
                data-testid={`about-paragraph-${i}`}
              >
                {p}
              </motion.p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
